import { useEffect, useState, useCallback } from "react";
import { useRealtime } from "./RealtimeProvider.jsx";

const STALE_MS = 8000;

// Seka, kurias eilutes/langelius ŠIUO METU redaguoja KITOS sesijos tai
// pačiai lentelei (savo pačios fokusavimas niekada negrįžta sau — serveris
// jau neatsiunčia atgal originatoriui, žr. realtime/registry.ts broadcast()).
// Presence niekada neišsaugoma DB — tai tik efemeriškas UI žymėjimas.
export function usePresence(tableId) {
  const realtime = useRealtime();
  const [entries, setEntries] = useState({}); // key: `${rowId}:${columnId}` -> {clientId, email, at}

  useEffect(() => {
    if (!realtime) return;
    return realtime.subscribe((msg) => {
      if (msg.type !== "presence" || msg.tableId !== tableId) return;
      const key = `${msg.rowId}:${msg.columnId ?? ""}`;
      setEntries((prev) => {
        if (msg.action === "blur") {
          if (!(key in prev)) return prev;
          const next = { ...prev };
          delete next[key];
          return next;
        }
        return { ...prev, [key]: { clientId: msg.clientId, email: msg.userEmail, at: Date.now() } };
      });
    });
  }, [realtime, tableId]);

  // Apsauga, jei "blur" pranešimas pasimetė (pvz. skirtukas uždarytas be
  // blur) — pasenusi žyma pati pašalinama po trumpo laiko be atnaujinimo.
  useEffect(() => {
    const interval = setInterval(() => {
      setEntries((prev) => {
        const now = Date.now();
        const next = {};
        let changed = false;
        for (const [key, entry] of Object.entries(prev)) {
          if (now - entry.at < STALE_MS) next[key] = entry;
          else changed = true;
        }
        return changed ? next : prev;
      });
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  const notifyFocus = useCallback(
    (rowId, columnId) => realtime?.sendPresence({ action: "focus", tableId, rowId, columnId }),
    [realtime, tableId],
  );
  const notifyBlur = useCallback(
    (rowId, columnId) => realtime?.sendPresence({ action: "blur", tableId, rowId, columnId }),
    [realtime, tableId],
  );
  const presenceFor = useCallback(
    (rowId, columnId) => entries[`${rowId}:${columnId ?? ""}`] || null,
    [entries],
  );

  return { notifyFocus, notifyBlur, presenceFor };
}
